module.exports = __webpack_public_path__ + "../static/img/switch-alert.7f6345c7.png";